import Vue from 'vue';
export default value => {
  if (!value) return '';
  const locale = Vue.$locale.locale;
  return (value.name18 && value.name18[locale]) || value.name;
};
